import { useMemo } from 'react';

import map from 'lodash/map';

import { useUnitsGet } from '@sbv-clients/data-access-api';
import { useProLaborLevelDesignations } from '@sbv-clients/data-access-api';
import { Select, useTransformSelectValue } from '@sbv-clients/ui-shared';

import { useAppendAllOption } from './util';
import useAutoSelectValue from './util/use-auto-select-value';

export function UnitFilter({
  withAllOption = false,
  autoSelectIfEmpty = false,
  useContextFn,
  errorMessages = {},
}: {
  withAllOption?: boolean;
  autoSelectIfEmpty?: boolean;
  useContextFn: () => {
    facilityId?: number;
    unitId: number;
    onUnitIdChange: (value: number) => void;
  };
  errorMessages?: Record<string, string>;
}) {
  const {
    facilityId,
    unitId: value,
    onUnitIdChange: onChange,
  } = useContextFn();

  const { data, isLoading, isSuccess } = useUnitsGet({
    facilityId,
    filteredByOpeningTemplates: true,
  });

  const options = useMemo(
    () =>
      map(data, (item) => ({
        id: String(item.unitId),
        label: item.name,
        value: item.unitId,
      })),
    [data]
  );
  useAppendAllOption(options, withAllOption);
  useAutoSelectValue({
    value,
    options,
    selectFirstAsDefault: autoSelectIfEmpty,
    callback: onChange,
    isSuccess,
  });

  const handleChange = useTransformSelectValue(onChange);
  const helperText = errorMessages['unitId'];
  const { UnitLaborLevel } = useProLaborLevelDesignations();

  return (
    <Select
      isLoading={isLoading}
      fullWidth
      size="small"
      value={value}
      label={UnitLaborLevel}
      options={options}
      onChange={handleChange}
      error={!!helperText}
      helperText={helperText}
      hideStartAdornment={isLoading}
    />
  );
}
